import css from './DropDown.module.scss';
import React, { useState } from 'react';
import { cns } from '../../utils';
import Chevron from '../../assets/chevron-left.svg';
import { ClickAwayListener } from '@mui/material';

interface Option<T> {
    id: T;
    label: string;
}
interface DropdownProps<T> {
    handleChange: (value: T) => void;
    label: string;
    options: Option<T>[];
    selected: T;
    className?: string;
}

export const Dropdown = <T,>({ handleChange, options, label, selected, className }: DropdownProps<T>) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen((previousState) => !previousState);
    };

    const handleSelect = (value: T) => {
        handleChange(value);
    };

    return (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <button
                type="button"
                id="container"
                className={cns(css.dropdownContainer, className)}
                onClick={toggleDropdown}
            >
                <div className={css.dropdownDisplay}>
                    <span>{label}</span>
                    <span className={css.amount}>
                        {options.find((option) => option.id === selected)?.label || String(selected)}
                    </span>
                </div>
                <div className={cns(css.chevron, isOpen && css.flipped)}>
                    <Chevron />
                </div>
                {isOpen && (
                    <div className={css.dropdownMenu}>
                        {options.map((option) => (
                            <button
                                key={String(option.id)}
                                className={css.dropdownItem}
                                onClick={() => handleSelect(option.id)}
                            >
                                <div className={css.dropdownText}>{option.label}</div>
                            </button>
                        ))}
                    </div>
                )}
            </button>
        </ClickAwayListener>
    );
};